export default "__VITE_ASSET__f2y4WlRx__"